import {Injectable} from '@angular/core';
import {AbstractSaveOneService} from '../../../core/service/v2/service/save/abstractSaveOne.service';
import {ProductModel} from '../../api/entity/product.model';
import {ProductSavePayload} from './payload/ProductSave.payload';
import {ProductRepository} from './ngrx-data/product.repository';
import {ProductDataServiceAdapter} from './ngrx-data/productDataService.adapter';

@Injectable()
export class ProductSaveService extends AbstractSaveOneService<ProductModel, ProductSavePayload> {

    constructor(repository: ProductRepository,
                dataServiceAdapter: ProductDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }
}
